module.exports = "<p>employee-csr works!</p>\n"